// Custom: mobile filter drawer was closing itself as soon as a filter was tapped.
//
// The mobile filter panel is a <menu-drawer> (assets/global.js, stock Dawn). MenuDrawer listens
// for `focusout` bubbling up to itself and, on a same-tick timeout, closes its main <details> if
// focus is no longer found anywhere inside it:
//
//   onFocusOut() {
//     setTimeout(() => {
//       if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
//         this.closeMenuDrawer();
//     });
//   }
//
// That's the right behavior for the site nav drawer (tab/click truly outside it -> close it), but
// our filter drawer's own controls routinely cause a *momentary* focus loss that isn't really the
// shopper leaving the panel:
//   - Tapping a group-toggle row (e.g. "За Дома") or any other in-drawer <button> can, depending on
//     the browser's click/focus timing, blur the previously-focused element before the new one
//     settles, and MenuDrawer's check runs before focus "lands" anywhere it recognizes as inside
//     itself.
//   - Checking a filter checkbox debounces an AJAX re-render (assets/facets.js, ~800ms after the
//     last `input` event) that swaps the filter's option list via outerHTML
//     (FacetFiltersForm.renderMobileCounts -> `.mobile-facets__list`). The checkbox the shopper
//     just tapped still has focus at that point, so removing it from the DOM fires a native
//     `focusout` with nowhere for focus to go.
// Either way, MenuDrawer sees "focus isn't inside me" and closes the ENTIRE "Филтри" panel instead
// of just continuing the filtering interaction.
//
// Fix: in the focusout CAPTURE phase (i.e. before MenuDrawer's own bubble-phase listener runs),
// stop propagation for any focusout whose target is inside our mobile filter drawer
// (`.mobile-facets__wrapper`). MenuDrawer's onFocusOut never fires for these, so it can no longer
// auto-close the panel out from under a shopper who is still interacting with it. The drawer's
// other, deliberate close paths (tapping the X / the "Филтриране и сортиране" bar again, Escape,
// the Apply/Clear buttons) don't go through onFocusOut at all, so they keep working unchanged.
(function () {
  document.addEventListener(
    'focusout',
    function (event) {
      if (event.target.closest('.mobile-facets__wrapper')) {
        event.stopPropagation();
      }
    },
    true
  );
})();
